export const Platform = Object.freeze({
  W2: 2,
  W3: 3,
  Picture: 4,
  W6: 6,
  W7: 7,
  CPU8: 8,
  W9: 9, // 同为效果图
  W10: 10, // CPU十区
  CPU11: 11, // CPU十一区
  CPU9: 13, // CPU九区
  QY3: 14, // GPU青云三区
  GPU: 21,
  QY: 22, // CPU青云
  GPU31: 31, // GPU四区
  GPU32: 32, // 京东
  PictureDev: 20, // 开发环境用，废弃预定
  GPU35: 35,
  GPU36: 36,
  CPU37: 37, // CPU十四区
  CPU38: 38, // CPU十三区
  GPU39: 39, // GPU6区
  GPUQY: 40, // GPU青云一区
  GPU7: 41, // 腾讯云
  CPU42: 42, // 亚马逊
  GPU43: 43, // 阿里云
  CPU44: 44, // 滴滴云
  CPU45: 45, // 抚州
  CPU46: 46, // 京东云
  CPU47: 47, // 上海电信
  CPU48: 48, // 移动云
  GPU49: 49, // 移动云
  CPU10: 10,
  GPUQY2: 50, // GPU青云一区
  DAYAN: 24, // 大雁GPU一区
  Picture3: 25, // 效果图三区
  GPU11: 26, // GPU十一区
  CPU21: 51, // CPU二十一区
  GPU12: 52, // GPU十二区
  DAYAN2: 53, // 大雁GPU二区
  DAYAN3: 54, // 大雁GPU三区
  CPU40: 55, // CPU四十区
  CPU41: 56, // CPU四十一区
  GPU41: 57, // GPU四十一区
  GPU40: 58, // GPU四十区
  GPU61: 61, // GPU二区
})

export const PictureList = [Platform.PictureDev, Platform.Picture, Platform.W9, Platform.Picture3]
export const CPUPlatformList = [
  Platform.W2,
  Platform.W3,
  Platform.W6,
  Platform.W7,
  Platform.W10,
  Platform.CPU11,
  Platform.CPU37,
  Platform.CPU38,
  Platform.CPU42,
  Platform.CPU44,
  Platform.CPU45,
  Platform.CPU46,
  Platform.CPU47,
  Platform.CPU48,
  Platform.QY,
  Platform.QY2,
  Platform.QY3,
  Platform.CPU21,
  Platform.CPU8,
  Platform.CPU40,
  Platform.CPU41,
  Platform.CPU9,
]
export const GPUPlatformList = [
  Platform.GPU,
  Platform.GPU31,
  Platform.GPU32,
  Platform.GPU35,
  Platform.GPU36,
  Platform.GPU39,
  Platform.GPUQY,
  Platform.GPUQY2,
  Platform.GPU7,
  Platform.GPU43,
  Platform.GPU49,
  Platform.DAYAN,
  Platform.DAYAN2,
  Platform.GPU11,
  Platform.GPU12,
  Platform.DAYAN3,
  Platform.GPU41,
  Platform.GPU40,
  Platform.GPU42,
  Platform.GPU61,
]
export const QYPlatformList = [Platform.QY, Platform.QY2, Platform.QY3, Platform.GPUQY, Platform.GPUQY2]

export const DYPlatformList = [
  Platform.DAYAN,
  Platform.DAYAN2,
  Platform.DAYAN3,
]

export const platformShowRouteList = [
  'taskOverview',
  'dytaskOverview',
  'analysisRunning',
  'analysisEnd',
  'preHandle',
  'renderRunning',
  'renderEnd',
  'renderNodeList',
  'rentNodeList',
  'nodeMachineChecklist',
  'index',
  'overview',
  'dyoverview',
  'productRunning',
  'productEnd',
  'publish',
  'rebuildRunning',
  'rebuildEnd',
  'sky3End',
  'emptyThreeRunning',
  'administratorNotice',
  'log',
  'scheduleConfig',
  'management',
  'constraintList',
  'engineList',
  'lineConfig',
  'asperaAccountConfig',
  'staffAndNodeNoticeList',
  'hardwareConfiguration',
  'hardwareModelToPerformance',
  'taskCategory',
  'desktop-manage',
  'desktop-node',
]

export const PlatformType = Object.freeze({
  GPU: 0,
  CPU: 1,
  Picture: 2,
  QY: 3,
})

export const PlatformTypeValue = Object.freeze({
  0: 'GPU',
  1: 'CPU',
  2: 'Picture',
  3: 'QY',
})

export const PlatformTypeSort = Object.freeze({
  CPU: 0,
  GPU: 1,
  QY: 2,
  Picture: 3,
})
